import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function TrendingSection() {
  const trendingArticles = articles.filter((a) => a.isHot).slice(0, 4);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 flex items-center justify-center text-primary-500">
            <i className="ri-fire-fill text-xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门推荐
          </h2>
        </div>
        <Link
          to="/category/hot"
          className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap"
        >
          查看全部
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {trendingArticles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}